// ArchivalTableRow.tsx — same file ke upar ya alag file mein

import { formatDisplayDateTime } from "../../../utils/Date";
import { getStatusBadge } from "./reportUtils";
import  type  { ArchivalRequest } from "./ArchivalRequest.types";

const ArchivalTableRow: React.FC<{
  item: ArchivalRequest;
  idx: number;
  currentPage: number;
  pageSize: number;
}> = ({ item, idx, currentPage, pageSize }) => {
  
  const requester =
    item.userId?.username ||
    `${item.userId?.firstName || ""} ${item.userId?.lastName || ""}`.trim() ||
    item.userId?._id ||
    "—";

  const renderActionCell = () => {
    if (item.status === "Rejected") {
      return (
        <div>
          <div className="font-medium text-sm">{item.decisionReason || "—"}</div>
          <div className="text-xs text-gray-400 mt-1">
            {item.decisionDate ? formatDisplayDateTime(item.decisionDate) : "—"}
          </div>
        </div>
      );
    }
    if (item.status === "Approved") {
      return (
        <div className="text-sm">
          {item.decisionDate ? formatDisplayDateTime(item.decisionDate) : "—"}
        </div>
      );
    }
    return <>—</>;
  };

  return (
    <tr key={idx} className="hover:bg-gray-50 transition-colors">
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {(currentPage - 1) * pageSize + idx + 1}
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          {item.requestId || "—"}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white text-sm font-medium mr-3">
            {requester?.charAt(0)?.toUpperCase() || "—"}
          </div>
          <div className="text-sm font-medium text-gray-900">{requester}</div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        {formatDisplayDateTime(item.createdAt)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        {getStatusBadge(item.status)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {item.controllerName || "—"}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">
        {renderActionCell()}
      </td>
    </tr>
  );
};

export default ArchivalTableRow